import React from 'react';

export default class UPLUSLogoInnerLogo extends React.Component {
  render() {

    const styles = {
      st0: { fill: '#FFFFFF' }   
    };
    return (<div className="logo">

      <svg width="170px" height="49px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
	 viewBox="0 0 170 49" style={{ enableBackground: 'new 0 0 170 49' }} >
	  
	  <g>
	<path style={styles.st0} d="M8.8,22.4H7.7c-0.1-0.3-0.2-0.6-0.2-0.8c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1h4.5
		c0.1,0.2,0.2,0.5,0.2,0.7c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.2,0.1-0.4,0.1h-0.7c0,0.8,0,2.8,0,5.8c0,2.5-0.5,4.1-1.5,5
		c-1,0.9-2.4,1.3-4.3,1.3c-1.7,0-2.9-0.3-3.6-1c-0.7-0.6-1-1.8-1-3.6c0-4.3,0-6.8,0-7.6H0.2C0.1,22.1,0,21.8,0,21.6
		c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1h4.6c0.1,0.2,0.2,0.5,0.2,0.7c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.2,0.1-0.4,0.1H4.2
		c0,0.9,0,2.7,0,5.7c0,1.9,0.2,3.1,0.6,3.7c0.4,0.6,1,0.9,1.8,0.9c0.9,0,1.5-0.3,1.8-0.8c0.4-0.5,0.5-1.6,0.5-3.1
		C8.9,25.4,8.9,23.2,8.8,22.4z"/>
	<path style={styles.st0} d="M16.8,22.4h-1.3c-0.1-0.3-0.2-0.6-0.2-0.8c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1h4.7
		c2.5,0,4.2,0.3,5.1,0.9c0.9,0.6,1.3,1.6,1.3,3c0,1.4-0.5,2.5-1.6,3.4s-2.7,1.2-5.1,1.2h-0.5c0,1.7,0,2.8,0,3.5h1.6
		c0.1,0.2,0.2,0.5,0.2,0.7c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.2,0.1-0.4,0.1h-5.6c-0.1-0.3-0.2-0.6-0.2-0.8c0-0.2,0-0.3,0.1-0.4
		c0.1-0.1,0.2-0.1,0.4-0.1h0.9c0-0.8,0-3,0-6.5C16.8,24.6,16.8,23.2,16.8,22.4z M20.7,28c1,0,1.7-0.2,2.2-0.5c0.5-0.4,0.7-1,0.7-1.9
		c0-0.8-0.2-1.5-0.7-1.9c-0.4-0.5-1.1-0.7-2.1-0.7c-0.4,0-0.7,0-1,0.1c0,0.4,0,1.6,0,3.5V28H20.7z"/>
	<path style={styles.st0} d="M32.7,32.7h0.2c2.2,0,3.9-0.3,5.2-0.8c0.3,0.4,0.4,0.9,0.4,1.4c0,0.4-0.1,0.6-0.4,0.8
		c-0.3,0.2-0.8,0.2-1.6,0.2l-8.1,0c-0.1-0.3-0.2-0.6-0.2-0.8c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1h0.7c0-0.8,0.1-3,0.1-6.5
		c0-1.9,0-3.3-0.1-4.1h-1.1c-0.1-0.3-0.2-0.6-0.2-0.8c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1H34c0.1,0.2,0.2,0.5,0.2,0.7
		c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.2,0.1-0.4,0.1h-0.9c0,0.8,0,2.2,0,4.1C32.6,30,32.6,32.1,32.7,32.7z"/>
	<path style={styles.st0} d="M48.2,22.4h-1.1c-0.1-0.3-0.2-0.6-0.2-0.8c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1H52
		c0.1,0.2,0.2,0.5,0.2,0.7c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.2,0.1-0.4,0.1h-0.7c0,0.8,0,2.8,0,5.8c0,2.5-0.5,4.1-1.5,5
		c-1,0.9-2.4,1.3-4.3,1.3c-1.7,0-2.9-0.3-3.6-1c-0.7-0.6-1-1.8-1-3.6c0-4.3,0-6.8,0-7.6h-0.9c-0.1-0.3-0.2-0.6-0.2-0.8
		c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1h4.6c0.1,0.2,0.2,0.5,0.2,0.7c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.2,0.1-0.4,0.1h-0.7
		c0,0.9,0,2.7,0,5.7c0,1.9,0.2,3.1,0.6,3.7c0.4,0.6,1,0.9,1.8,0.9c0.9,0,1.5-0.3,1.8-0.8c0.4-0.5,0.5-1.6,0.5-3.1
		C48.3,25.4,48.3,23.2,48.2,22.4z"/>
	<path style={styles.st0} d="M58.8,20.9c1.7,0,2.8,0.1,3.3,0.3c0.5,0.2,0.8,0.6,0.8,1.1c0,0.5-0.2,1-0.6,1.4c-1.5-0.7-2.8-1-3.9-1
		c-0.7,0-1.2,0.1-1.5,0.4c-0.3,0.3-0.4,0.6-0.4,1.1c0,0.6,0.2,1,0.5,1.3c0.4,0.3,1.1,0.6,2.2,0.9c1.4,0.4,2.4,0.8,3.1,1.4
		c0.7,0.5,1.1,1.4,1.2,2.7c0,1.4-0.5,2.4-1.5,3.1c-1,0.7-2.5,1-4.4,1c-1.4,0-2.4-0.1-3.1-0.3c-0.7-0.2-1-0.6-1-1.2
		c0-0.5,0.2-1,0.7-1.4c1.5,0.8,2.9,1.1,4.2,1.1c0.8,0,1.4-0.1,1.8-0.3c0.3-0.2,0.5-0.6,0.5-1.1c0-0.6-0.3-1.1-0.8-1.4
		c-0.5-0.3-1.4-0.7-2.6-1c-1.3-0.3-2.2-0.8-2.8-1.4c-0.6-0.6-0.8-1.4-0.8-2.3c0-1.3,0.5-2.3,1.4-3C55.9,21.2,57.2,20.9,58.8,20.9z"
		/>
	<g>
		<g>
			<g>
				<path style={styles.st0} d="M81.5,34.4h-4.1l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2H78
					c-0.1-0.6-0.4-1.5-0.7-2.6h-3.8c-0.3,1.2-0.5,2.1-0.7,2.6h0.7l0.1,0.2c0.1,0.2,0.1,0.4,0.1,0.7c0,0.2-0.1,0.4-0.2,0.5
					c-0.1,0.1-0.3,0.2-0.5,0.2h-3.7l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h0.3
					c0.4-1.2,1.1-3.2,2-6c1-3,1.6-4.7,1.8-5.2c0.3-0.6,0.8-0.8,1.5-0.8c1.1,0,1.2,0.1,1.4,0.1c0.1,0.1,0.2,0.1,2,5.4
					c1.1,3.2,1.9,5.4,2.3,6.5H82l0.1,0.2c0.1,0.2,0.1,0.4,0.1,0.7c0,0.2-0.1,0.4-0.2,0.5C81.9,34.4,81.8,34.4,81.5,34.4z M74,28.4
					h2.7c-0.8-2.5-1.2-3.7-1.4-4.4C75.1,24.7,74.7,25.9,74,28.4z"/>
			</g>
		</g>
		<g>
			<g>
				<path style={styles.st0} d="M87.9,34.6c-1.9,0-3.3-0.5-4.2-1.4c-0.9-0.9-1.4-2.5-1.4-4.9c0-2.6,0.5-4.5,1.6-5.7
					c1.1-1.2,2.6-1.9,4.7-1.9c1.1,0,2,0.1,2.6,0.3c0.9,0.3,1,0.8,1,1.2c0,0.4-0.2,0.8-0.6,1.2l-0.2,0.1l-0.2-0.1
					c-1.1-0.5-2.1-0.8-3.1-0.8c-1,0-1.7,0.3-2.2,1c-0.5,0.7-0.8,2-0.8,3.7c0,2,0.3,3.3,0.8,4.1c0.5,0.7,1.4,1.1,2.5,1.1
					c1.1,0,2-0.3,2.9-0.8l0.2-0.1l0.2,0.2c0.4,0.4,0.6,0.8,0.6,1.3c0,0.5-0.5,0.9-1.4,1.1C90.1,34.5,89.1,34.6,87.9,34.6z"/>
			</g>
		</g>
		<g>
			<g>
				<path style={styles.st0} d="M105.2,34.4H101l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h0.1
					c-0.1-0.6-0.4-1.5-0.7-2.6h-3.8c-0.3,1.2-0.5,2.1-0.7,2.6h0.7l0.1,0.2c0.1,0.2,0.1,0.4,0.1,0.7c0,0.2-0.1,0.4-0.2,0.5
					c-0.1,0.1-0.3,0.2-0.5,0.2H93l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h0.3
					c0.4-1.2,1.1-3.2,2-6c1-3,1.6-4.7,1.8-5.2c0.3-0.6,0.8-0.8,1.5-0.8c1.1,0,1.2,0.1,1.4,0.1c0.1,0.1,0.2,0.1,2,5.4
					c1.1,3.2,1.9,5.4,2.3,6.5h0.8l0.1,0.2c0.1,0.2,0.1,0.4,0.1,0.7c0,0.2-0.1,0.4-0.2,0.5C105.6,34.4,105.4,34.4,105.2,34.4z
					 M97.6,28.4h2.7c-0.8-2.5-1.2-3.7-1.4-4.4C98.7,24.7,98.4,25.9,97.6,28.4z"/>
			</g>
		</g>
		<g>
			<g>
				<path style={styles.st0} d="M106.6,34.4l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h0.4
					c0-1,0.1-3.2,0.1-6.4c0-1.7,0-3-0.1-3.9h-0.9l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2
					h3.8c2.6,0,4.4,0.5,5.5,1.4c1,1,1.5,2.5,1.5,4.7c0,2.4-0.5,4.2-1.5,5.5c-1,1.2-2.7,1.9-5.1,1.9L106.6,34.4z M110.3,23
					c0,1.1-0.1,3.3-0.1,6.7c0,2.1,0.2,2.5,0.2,2.5c0,0,0.2,0.2,1.5,0.2c1,0,1.8-0.3,2.3-0.9c0.5-0.6,0.8-1.9,0.8-3.7
					c0-1.9-0.3-3.2-0.9-3.9c-0.6-0.7-1.6-1-2.8-1C110.9,22.9,110.6,23,110.3,23z"/>
			</g>
		</g>
		<g>
			<g>
				<path style={styles.st0} d="M119.6,34.4l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h0.4
					c0-1,0.1-3.2,0.1-6.4c0-1.7,0-3-0.1-3.9h-0.9l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2
					h8.1c0.4,0,0.7,0.1,0.9,0.2c0.2,0.2,0.3,0.4,0.3,0.8c0,0.4-0.1,0.9-0.4,1.3l-0.1,0.2l-0.2-0.1c-1.1-0.5-2.8-0.7-4.8-0.7h-0.5
					c0,0.7,0,2,0,3.6h4.9l0.1,0.2c0.1,0.3,0.1,0.6,0.1,0.9c0,0.3-0.1,0.5-0.2,0.6c-0.1,0.1-0.3,0.2-0.6,0.2h-4.3
					c0,2.2,0,3.7,0.1,4.4h1c2,0,3.5-0.2,4.6-0.6l0.2-0.1l0.1,0.2c0.2,0.4,0.3,0.8,0.3,1.2c0,0.4-0.1,0.7-0.4,0.9
					c-0.2,0.2-0.6,0.2-1.3,0.2L119.6,34.4z"/>
			</g>
		</g>
		<g>
			<g>
				<path style={styles.st0} d="M145,34.4h-3.9l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h0.3
					c0-1.1,0-3.7,0-7.6c-0.4,1.2-0.7,2.5-1.1,3.7c-0.7,2-1.1,3.1-1.3,3.5c-0.3,0.5-0.7,0.7-1.3,0.7c-1,0-1.2-0.1-1.3-0.1
					c-0.1-0.1-0.2-0.1-1.4-3.4c-0.5-1.5-1-2.9-1.4-4.4c0,3.9,0,6.5,0,7.6h0.8l0.1,0.2c0.1,0.2,0.1,0.4,0.1,0.7
					c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2h-3.7l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5
					c0.1-0.1,0.3-0.2,0.5-0.2h0.4c0.1-0.9,0.1-2.6,0.2-5c0.1-2.4,0.1-4.2,0.1-5.4H131l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7
					c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h4.1l0.1,0.2c0.3,1.1,0.7,2.5,1.3,4.2c0.5,1.7,1,3.1,1.3,4.1
					c0.1,0.3,0.2,0.6,0.2,0.8c0.2-0.6,0.5-1.5,1-3.3c0.8-2.7,1.3-4.7,1.6-5.8l0.1-0.2h4.3l0.1,0.2c0.1,0.2,0.1,0.4,0.1,0.7
					c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2h-0.3c0,1.2,0,3,0.1,5.4c0.1,2.3,0.1,4,0.2,5h0.8l0.1,0.2
					c0.1,0.2,0.1,0.5,0.1,0.7c0,0.2-0.1,0.4-0.2,0.5C145.5,34.4,145.3,34.4,145,34.4z"/>
			</g>
		</g>
		<g>
			<g>
				<path style={styles.st0} d="M154.8,34.4h-4.9l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h0.8
					c0-0.8,0.1-1.7,0.1-2.7c-2-3.9-3.3-6.5-3.9-7.7h-0.8l-0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5
					c0.1-0.1,0.3-0.2,0.5-0.2h4l0.1,0.2c0.1,0.2,0.1,0.4,0.1,0.7c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2h-0.1
					c0.3,0.8,0.8,2,1.4,3.4c0.5,1.1,0.8,1.7,0.9,2.1c0.1-0.3,0.4-0.9,0.8-2c0.6-1.4,1-2.6,1.2-3.5h-0.6l-0.1-0.2
					c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h3.6l0.1,0.2c0.1,0.2,0.1,0.4,0.1,0.7
					c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2h-0.3c-0.7,1.2-1.9,3.8-3.7,7.5c0,1.1,0,2.1,0.1,2.9h1.3l0.1,0.2
					c0.1,0.2,0.1,0.4,0.1,0.7c0,0.2-0.1,0.4-0.2,0.5C155.2,34.4,155,34.4,154.8,34.4z"/>
			</g>
		</g>
	</g>
	<g>
		<path style={styles.st0} d="M162.5,19.7c0-2.3,1.7-3.9,3.7-3.9c2,0,3.7,1.6,3.7,3.9c0,2.4-1.7,3.9-3.7,3.9
			C164.2,23.6,162.5,22,162.5,19.7z M169.2,19.7c0-1.9-1.3-3.3-3-3.3c-1.7,0-3,1.4-3,3.3c0,1.9,1.3,3.3,3,3.3
			C167.9,22.9,169.2,21.6,169.2,19.7z M164.8,17.5h1.5c0.8,0,1.5,0.3,1.5,1.3c0,0.5-0.3,1-0.8,1.1l0.9,1.7h-0.9l-0.7-1.4h-0.8v1.4
			h-0.8V17.5z M166.1,19.6c0.6,0,0.9-0.2,0.9-0.7c0-0.4-0.2-0.7-0.8-0.7h-0.6v1.4H166.1z"/>
	</g>
</g>

</svg>

    </div>);
  }

}



// WEBPACK FOOTER //
// ./src/components/svglogos/InnerLogo/UPLUSLogoWhite.js